

import { loadScript } from "../../../globals/constants";
import SEO from "../seo";
import { useEffect, useState } from "react";
import { getAboutusPage, getPageInfo } from "../../../utils/func";
import PageBody from "../pageBody";
import { useParams } from "react-router-dom";

function CustomPage({
    siteName,
    pageTitle
}) {



    const [pageInfo,setPageInfo] = useState(null)

    const params = useParams()
    console.log("custom page param is ", params)

    useEffect(() => {
        getPageInfo(params?.id).then(result => {
        
            setPageInfo(result[0])
        }).catch(err => {
            console.log("26 page err",err)
        })
        
    }, [])

  
    useEffect(() => {
        loadScript("js/custom.js");
    })


    return (
        <>
            <SEO 
                siteName={siteName}
                pageTitle={pageInfo?.name}
                description={pageInfo?.description}
                keywords=""
            />

            {
                pageInfo && pageInfo?.body && (
                    <PageBody 
                        body={JSON.parse(pageInfo?.body)}
                        formspree_id={""}
                    />
                )
            }
        
        </>
    )
}
export default CustomPage;